"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _OrganisationMember = _interopRequireDefault(require("../../OrganisationMember/OrganisationMember"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.inapp-vorstand-container .bottom-section {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  width: 100%;\n  justify-content: flex-start;\n  column-gap: 16px; }\n\n.inapp-vorstand-container .info-container {\n  margin-left: 0px; }\n\n@media (max-width: 66rem) {\n  .inapp-vorstand-container .bottom-section {\n    grid-template-columns: repeat(3, minmax(0, 1fr)); }\n  .inapp-vorstand-container .info-container {\n    width: 100%;\n    max-width: 312px; } }\n\n@media (max-width: 42rem) {\n  .inapp-vorstand-container .bottom-section {\n    grid-template-columns: repeat(2, minmax(0, 1fr)); }\n  .inapp-vorstand-container .info-container {\n    width: 100%;\n    max-width: 288px; } }\n";
  const fileName = "InAppVorstand_InAppVorstand";
  const element = document.querySelector("style[data-sass-component='InAppVorstand_InAppVorstand']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const formatItems = data => {
  const co_presidents = data.co_presidents || [];
  const members = data.members || [];
  const presidents = data.presidents || [];
  const vice_presidents = data.vice_presidents || [];
  return [...presidents, ...co_presidents, ...vice_presidents, ...members].map(member => {
    return {
      firstname: member.firstname,
      picture: member.image ? 'data:image/png;base64,' + member.image : undefined,
      lastname: member.lastname,
      email: member.email,
      gender: member.gender,
      sia_membership: member.member_type,
      professional_group_membership: member.professional_group[0]?.name || '',
      section_memberships: member.sections?.map(section => section.name || section.code),
      academic_title: member.academic_title || '',
      diploma_title: member.diploma_title,
      role: member.role
    };
  });
};
const InAppVorstand = _ref => {
  let {
    data
  } = _ref;
  const [items, setItems] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (data) {
      const data_formatted = formatItems(data);
      const values = data_formatted.reduce((foundValues, nextItem) => {
        const findedItem = foundValues.find(item => item.email === nextItem.email);
        if (findedItem && findedItem.role) {
          findedItem.role = findedItem.role + '<br>' + nextItem.role;
        } else {
          foundValues.push(nextItem);
        }
        return foundValues;
      }, []);
      setItems(values);
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "inapp-vorstand-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "bottom-section"
  }, items.map((employee, index2) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "employee",
      key: index2
    }, /*#__PURE__*/_react.default.createElement(_OrganisationMember.default, employee));
  })));
};
var _default = exports.default = InAppVorstand;